import {contactMethodsLinks} from "@utils/types/contactMethodsTypes";
import SetInnerHtml from "@components/setInnerHtml";

const SocialMedia = ({data}) => {
    return (
        <>
            <div className="link-sections-section-items w-fit d-flex align-items-start flex-row">
                {data?.map((item) => (
                    <div
                        key={item.id}
                        className="link-sections-section-items-item social-medium mx-1"
                    >
                        <a
                            href={contactMethodsLinks(item.type, item.value)}
                            rel="noreferrer"
                            target="_blank"
                            title={`${item.title}: ${item.value}`}
                            className="d-flex align-items-center mb-1"
                        >
                            <SetInnerHtml html={item.icon}/>
                            {/*<small className="ml-1">{item.title}</small>*/}
                        </a>
                    </div>
                ))}
            </div>
        </>
    );
};

export default SocialMedia;